import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  IDialogContentProps,
  PrimaryButton,
} from "@fluentui/react";

interface ConfirmCancelProps {
  title: string;
  children: React.ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
  confirmText?: string;
  cancelText?: string;
  disableConfirm?: boolean;
}

export const ConfirmDialog = ({
  title,
  children,
  onCancel,
  onConfirm,
  confirmText,
  cancelText,
  disableConfirm,
}: ConfirmCancelProps) => {
  const content: IDialogContentProps = {
    type: DialogType.normal,
    title,
  };
  const confirmButtonText = confirmText || "Yes";
  const cancelButtonText = cancelText || "No";

  return (
    <Dialog
      hidden={false}
      onDismiss={onCancel}
      dialogContentProps={content}
      modalProps={dialogModalProps}
    >
      {children}
      <DialogFooter>
        <PrimaryButton
          disabled={disableConfirm}
          onClick={onConfirm}
          text={confirmButtonText}
          ariaLabel="Confirm"
        />
        <DefaultButton
          onClick={onCancel}
          text={cancelButtonText}
          ariaLabel="Cancel action"
        />
      </DialogFooter>
    </Dialog>
  );
};

const dialogModalProps = {
  isBlocking: true,
  styles: { main: { maxWidth: 450 } },
};
